<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 604 436"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="placement-container"
    >
        <g filter="url(#filter0_d_121_2773)">
            <rect x="62" y="60" width="480" height="316" rx="20" fill="white" />
        </g>
        <path
            d="M94 105H110V103H94V105ZM94 101H110V99H94V101ZM94 95V97H110V95H94Z"
            fill="black"
            fill-opacity="0.54"
        />
        <path
            d="M168.656 105.256C167.579 105.256 166.587 104.995 165.68 104.472C164.773 103.949 164.053 103.229 163.52 102.312C162.987 101.395 162.72 100.381 162.72 99.272C162.72 98.1627 162.987 97.1493 163.52 96.232C164.053 95.3147 164.773 94.5947 165.68 94.072C166.587 93.5493 167.579 93.288 168.656 93.288C169.499 93.288 170.288 93.4373 171.024 93.736C171.771 94.0347 172.384 94.456 172.864 95L171.888 95.976C171.525 95.528 171.061 95.1867 170.496 94.952C169.931 94.7067 169.323 94.584 168.672 94.584C167.861 94.584 167.104 94.7813 166.4 95.176C165.707 95.56 165.147 96.1093 164.72 96.824C164.304 97.528 164.096 98.344 164.096 99.272C164.096 100.2 164.304 101.021 164.72 101.736C165.147 102.44 165.712 102.989 166.416 103.384C167.12 103.768 167.872 103.96 168.672 103.96C169.44 103.96 170.08 103.843 170.592 103.608C171.115 103.363 171.563 103.043 171.936 102.648C172.213 102.349 172.437 101.992 172.608 101.576C172.779 101.149 172.885 100.68 172.928 100.168H168.688V98.904H174.192C174.245 99.2027 174.272 99.48 174.272 99.736C174.272 100.44 174.16 101.128 173.936 101.8C173.712 102.461 173.355 103.043 172.864 103.544C171.808 104.685 170.405 105.256 168.656 105.256ZM175.768 96.84H177.064V98.04H177.128C177.362 97.624 177.714 97.2773 178.184 97C178.653 96.7227 179.149 96.584 179.672 96.584C180.269 96.584 180.786 96.728 181.224 97.016C181.672 97.304 181.992 97.688 182.184 98.168C182.472 97.688 182.85 97.304 183.32 97.016C183.8 96.728 184.354 96.584 184.984 96.584C185.922 96.584 186.626 96.872 187.096 97.448C187.576 98.0133 187.816 98.7867 187.816 99.768V105H186.472V99.976C186.472 99.2187 186.317 98.6693 186.008 98.328C185.698 97.9867 185.24 97.816 184.632 97.816C184.226 97.816 183.858 97.9333 183.528 98.168C183.197 98.4027 182.936 98.7173 182.744 99.112C182.562 99.5067 182.472 99.9333 182.472 100.392V105H181.112V99.992C181.112 99.224 180.957 98.6693 180.648 98.328C180.338 97.9867 179.885 97.816 179.288 97.816C178.882 97.816 178.514 97.9387 178.184 98.184C177.853 98.4187 177.592 98.7387 177.4 99.144C177.218 99.5387 177.128 99.9653 177.128 100.424V105H175.768V96.84ZM192.042 105.256C191.444 105.256 190.911 105.139 190.442 104.904C189.972 104.669 189.61 104.349 189.354 103.944C189.098 103.528 188.97 103.059 188.97 102.536C188.97 101.672 189.295 101 189.946 100.52C190.596 100.029 191.418 99.784 192.41 99.784C192.9 99.784 193.354 99.8373 193.77 99.944C194.196 100.051 194.522 100.173 194.746 100.312V99.816C194.746 99.208 194.532 98.7227 194.106 98.36C193.679 97.9867 193.14 97.8 192.49 97.8C192.031 97.8 191.61 97.9013 191.226 98.104C190.842 98.296 190.538 98.568 190.314 98.92L189.29 98.152C189.61 97.6613 190.047 97.2773 190.602 97C191.167 96.7227 191.791 96.584 192.474 96.584C193.583 96.584 194.452 96.8773 195.082 97.464C195.722 98.04 196.042 98.8293 196.042 99.832V105H194.746V103.832H194.682C194.447 104.227 194.095 104.563 193.626 104.84C193.156 105.117 192.628 105.256 192.042 105.256ZM192.17 104.056C192.628 104.056 193.055 103.939 193.45 103.704C193.844 103.469 194.159 103.155 194.394 102.76C194.628 102.365 194.746 101.933 194.746 101.464C194.49 101.293 194.175 101.155 193.802 101.048C193.428 100.941 193.034 100.888 192.618 100.888C191.871 100.888 191.306 101.043 190.922 101.352C190.548 101.661 190.362 102.061 190.362 102.552C190.362 103 190.532 103.363 190.874 103.64C191.215 103.917 191.647 104.056 192.17 104.056ZM198.477 95.336C198.211 95.336 197.981 95.24 197.789 95.048C197.597 94.856 197.501 94.6267 197.501 94.36C197.501 94.0933 197.597 93.8693 197.789 93.688C197.981 93.496 198.211 93.4 198.477 93.4C198.744 93.4 198.973 93.496 199.165 93.688C199.357 93.8693 199.453 94.0933 199.453 94.36C199.453 94.6267 199.357 94.856 199.165 95.048C198.984 95.24 198.755 95.336 198.477 95.336ZM197.805 96.84H199.149V105H197.805V96.84ZM201.031 93.544H202.391V105H201.031V93.544Z"
            fill="#444444"
        />
        <g clip-path="url(#clip0_121_2773)">
            <path
                d="M132.364 109.902V99.6518L129.009 96.7437L126 95.1299V108.093C126 109.094 126.856 109.902 127.909 109.902H132.364Z"
                fill="#4285F4"
            />
            <path
                d="M147.637 109.902H152.091C153.148 109.902 154 109.091 154 108.093V95.1301L150.593 96.9785L147.637 99.6518V109.902Z"
                fill="#34A853"
            />
            <path
                d="M132.363 99.6518L131.906 95.647L132.363 91.8139L139.999 97.2402L147.635 91.8139L148.146 95.44L147.635 99.6518L139.999 105.078L132.363 99.6518Z"
                fill="#EA4335"
            />
            <path
                d="M147.637 91.8139V99.6518L154 95.13V92.7183C154 90.4815 151.305 89.2064 149.419 90.5478L147.637 91.8139Z"
                fill="#FBBC04"
            />
            <path
                d="M126 95.1299L128.927 97.2097L132.364 99.6518V91.8138L130.582 90.5477C128.692 89.2062 126 90.4814 126 92.7181V95.1298V95.1299Z"
                fill="#C5221F"
            />
        </g>
        <rect opacity="0.1" x="62" y="140" width="480" height="68" fill="#FF2828" />
        <rect x="242" y="90" width="268" height="20" rx="6" fill="#F0F0F5" />
        <rect x="94" y="152" width="16" height="16" rx="6" fill="white" />
        <rect x="126" y="152" width="384" height="16" rx="6" fill="white" />
        <rect opacity="0.5" x="131" y="157" width="16" height="6" rx="3" fill="#FF9500" />
        <rect x="94" y="180" width="16" height="16" rx="6" fill="white" />
        <rect x="126" y="180" width="384" height="16" rx="6" fill="white" />
        <rect opacity="0.5" x="131" y="185" width="16" height="6" rx="3" fill="#FF9500" />
        <rect x="94" y="220" width="16" height="16" rx="6" fill="#F0F0F5" />
        <rect x="126" y="220" width="384" height="16" rx="6" fill="#F0F0F5" />
        <rect x="94" y="248" width="16" height="16" rx="6" fill="#F0F0F5" />
        <rect x="126" y="248" width="384" height="16" rx="6" fill="#F0F0F5" />
        <rect x="94" y="276" width="16" height="16" rx="6" fill="#F0F0F5" />
        <rect x="126" y="276" width="384" height="16" rx="6" fill="#F0F0F5" />
        <rect x="94" y="304" width="16" height="16" rx="6" fill="#F0F0F5" />
        <rect x="126" y="304" width="384" height="16" rx="6" fill="#F0F0F5" />
        <rect x="94" y="332" width="16" height="16" rx="6" fill="#F0F0F5" />
        <rect x="126" y="332" width="384" height="16" rx="6" fill="#F0F0F5" />
        <circle cx="542" cy="140" r="11" fill="#FB3535" />
        <path
            d="M545 137L542 140M539 143L542 140M542 140L539 137M542 140L545 143"
            stroke="white"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <defs>
            <filter
                id="filter0_d_121_2773"
                x="26"
                y="48"
                width="552"
                height="388"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feMorphology
                    radius="12"
                    operator="erode"
                    in="SourceAlpha"
                    result="effect1_dropShadow_121_2773"
                />
                <feOffset dy="24" />
                <feGaussianBlur stdDeviation="24" />
                <feComposite in2="hardAlpha" operator="out" />
                <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0" />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow_121_2773"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_dropShadow_121_2773"
                    result="shape"
                />
            </filter>
            <clipPath id="clip0_121_2773">
                <rect width="28" height="20" fill="white" transform="translate(126 90)" />
            </clipPath>
        </defs>
    </svg>
</template>
<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        width: {
            type: String,
            required: true,
            default: '100%',
        },
        height: {
            type: String,
            required: true,
            default: 'auto',
        },
    },
})
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/variables.scss';

.placement-container {
    @include bg-opteo-light-gray;
    @include br-20;
}
</style>
